// Extract YouTube video ID from various URL formats
const PATTERNS = [
  /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
];

export const extractYouTubeId = (url) => {
  if (!url) return null;
  const s = String(url).trim();
  for (const p of PATTERNS) {
    const m = s.match(p);
    if (m) return m[1];
  }
  // Plain 11-char ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  return null;
};

// High-quality auto-generated YouTube thumbnail
// Try maxresdefault first; some older videos only have hqdefault
export const ytThumbnail = (youtubeId, quality = "maxresdefault") =>
  `https://i.ytimg.com/vi/${youtubeId}/${quality}.jpg`;

// Embed URL with our standard params
export const ytEmbedUrl = (youtubeId, opts = {}) => {
  const p = new URLSearchParams({
    rel: "0",
    modestbranding: "1",
    playsinline: "1",
    ...(opts.autoplay ? { autoplay: "1" } : {}),
    ...(opts.mute ? { mute: "1" } : {}),
    ...(opts.loop ? { loop: "1", playlist: youtubeId } : {}),
    ...(opts.controls === false ? { controls: "0" } : {}),
  });
  return `https://www.youtube-nocookie.com/embed/${youtubeId}?${p.toString()}`;
};
